import { useDataChange, useDataValue } from 'Simple/Data.js'

export function useOnClick(props) {
  let letter_idx = useDataValue({
    context: 'letter_item',
    viewPath: props.viewPath,
    path: 'index',
  })

  let change = useDataChange({
    context: 'modal',
    viewPath: props.viewPath,
  })

  return function onClick() {
    change(next => {
      next.letters.splice(letter_idx, 1)
    })
  }
}
